function getLetter(index, unknown) {
    const alphabet = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "ch",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
    ];
    return alphabet[index] ?? unknown;
}
function sourcesByWidth(file) {
    const sources = [];
    sources.push([file.detail.width, file.source]);
    for (const variant of file.variants) {
        sources.push([variant.detail.width, variant.source]);
    }
    sources.sort((a, b) => a[0] > b[0]);
    return sources;
}
function sourcesToSrcSet(sources) {
    const items = [];
    for (const item of sources) {
        items.push(`${item[1]} ${item[0]}w`);
    }
    return items.join(",\r\n");
}
async function requestFullScreen(element) {
    const requestMethod = element.requestFullscreen ||
        element.webkitRequestFullscreen ||
        element.mozRequestFullscreen ||
        element.msRequestFullscreen;
    if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
    }
    else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        const wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
            wscript.SendKeys("{F11}");
        }
    }
}
async function videoToImage(src, frameTimeInSeconds = 0.5) {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const video = document.createElement("video");
        const source = document.createElement("source");
        const context = canvas.getContext("2d");
        video.style.display = "none";
        canvas.style.display = "none";
        source.setAttribute("src", src);
        video.setAttribute("crossorigin", "anonymous");
        video.setAttribute("preload", "metadata");
        video.appendChild(source);
        document.body.appendChild(canvas);
        document.body.appendChild(video);
        if (!context) {
            return;
        }
        video.addEventListener("loadedmetadata", function () {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
        });
        video.addEventListener("seeked", function () {
            context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
            canvas.toBlob((blob) => {
                let url = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
                if (blob !== null) {
                    url = URL.createObjectURL(blob);
                }
                resolve(url);
            });
        });
        video.currentTime = frameTimeInSeconds;
        video.load();
    });
}
async function createBlobUrl(source) {
    const response = await fetch(source);
    return URL.createObjectURL(await response.blob());
}
export { getLetter, sourcesByWidth, sourcesToSrcSet, requestFullScreen, videoToImage, createBlobUrl };
